import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function TriangleArrowLeftIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M22.1426 1.44245L7.74248 14.3619C6.75251 15.2501 6.75251 16.7498 7.74248 17.638L22.1426 30.5575C23.2246 31.5282 25 30.797 25 29.3807V2.61942C25 1.20297 23.2246 0.471794 22.1426 1.44245Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
